import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { SubmitPolicyholderDataClientResponse } from '../@types/SubmitPolicyholderData'

type Store = {
  submitPolicyHolderData: SubmitPolicyholderDataClientResponse | null
  setSubmitPolicyHolderData: (
    value: SubmitPolicyholderDataClientResponse,
  ) => void
}

export const SubmitPolicyHolderDataStore = create<Store>()(
  devtools(
    (set) => ({
      submitPolicyHolderData: null,
      setSubmitPolicyHolderData: (submitPolicyHolderData) =>
        set({ submitPolicyHolderData }),
    }),
    { name: 'SubmitPolicyHolderDataStore' },
  ),
)
